import moment from 'moment';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import parse, { attributesToProps, domToReact } from 'html-react-parser';

import { Element } from 'domhandler/lib/node';
import { Bucket } from 'src/services/http-service';
import { ApiGetNoAuth, ApiPostNoAuth } from 'src/helpers/API/ApiData';

const Blog_details = () => {
  const location: any = useLocation();
  const history = useHistory();

  const option = {
    replace: (domNode: any) => {
      if (
        domNode instanceof Element &&
        domNode.attribs &&
        domNode.attribs.target == '_blank'
      ) {
        const props = attributesToProps(domNode.attribs);
        if (props.href == '') {
          delete props.href;
          delete props.target;
        }
        return <a {...props}>{domToReact(domNode.children, option)}</a>;
      }
    }
  };

  const data1 = location.state;
 
  

  const [data, setData] = React.useState([]);
  const [categoryData, setcategoryData] = React.useState([]);
  
  useEffect(() => {
    const body = {
      search: '',
      page: 1,
      limit: 1000
    };
    ApiPostNoAuth('user/blog/get', body).then((res: any) => {
      setData(res?.data?.data?.blog_data);
    });

    ApiGetNoAuth('user/category/get?blog=true').then((res: any) => {
      setcategoryData(res?.data?.data);
    });
  }, []);

  const blogDetails = (q: any) => {
    history.push({
      pathname: '/blog_details',
      state: q
    });
  };
  const hasBlogContent = Boolean(data1?.title && data1?.html_code);

  if (!hasBlogContent) {
    return (
      <div className="primary-content-area container content-padding text-center py-5">
        <h1>Blog post not found</h1>
        <p>This article is unavailable or was opened without content.</p>
        <button className="btn btn-dark mt-3" onClick={() => history.push('/blog_list')}>
          Browse blog
        </button>
      </div>
    );
  }

  return (
    <>
      <div className="primary-content-area container content-padding">
        <div className="single-post single-post-sidebar grid-right-sidebar-large">
          <div className="single-post-body">
            <div className="post-heading">
              <div className="news-tags">
                <span className="tag-item">
                  <span>{data1?.category[0]?.name}</span>
                </span>
              </div>
              <h1>{data1?.title}</h1>
              <div className="news-meta">
                <div className="post-author">
                  by <span>Unicorn UI</span>,{' '}
                  {moment(data1?.createdAt).format('MMMM DD,YYYY')}
                </div>
                <ul className="social-icons-list">
                  <li className="social-icon">
                    <span>
                      <svg className="crumina-icon"></svg>
                    </span>
                  </li>
                  <li className="social-icon">
                    <span>
                      <svg className="crumina-icon"></svg>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="post-featured-image">
              {data1?.URLs[0]?.includes('.mp4') ? (
                <video
                  src={Bucket + data1?.URLs[0]}
                  style={{ width: '100%', height: '100%' }}
                  controls
                ></video>
              ) : (
                  <img src={Bucket + data1?.URLs[0]} className="img-fluid" alt='image' />
              )}
            </div>
            <div className="post-content">
              {parse(data1?.html_code, option)}
            </div>
          </div>
          <aside>
            <div className="widgets-list">
              <div className="widget-2 recent-posts-widget">
                <div className="widget-title h5">Latest News</div>
                <div className="widget-body">
                  {data.map((e: any, i: any) => {
                    return (
                      i <= 2 && (
                        <div className="recent-posts-widget-item">
                          <div className="recent-posts-widget-item-img">
                            <span style={{ cursor: 'pointer' }} onClick={() => blogDetails(e)}>
                              <img
                                src={Bucket + e?.URLs[0]}
                                alt='image' 
                                style={{ height: '100%' }}
                              />
                            </span>
                          </div>
                          <div className="recent-posts-widget-item-info">
                            <div className="recent-posts-widget-item-tags">
                              <span className="tag-item" >
                                {e?.category[0]?.name}
                              </span>
                            </div>
                            <div className="recent-posts-widget-item-title">
                              <span style={{ cursor: 'pointer' }} onClick={() => blogDetails(e)}>{e?.title}</span>
                            </div>
                            <div className="recent-posts-widget-item-meta">
                              by <span>Unicorn UI</span>,{' '}
                              {moment(e?.createdAt).format('MMMM DD,YYYY')}
                            </div>
                          </div>
                        </div>
                      )
                    );
                  })}
                </div>
              </div>

              <div className="widget-2 categories-widget">
                <div className="widget-title h5">Categories</div>
                <div className="widget-body">
                  <div className="categories-widget-list">
                    {categoryData?.map((e: any) => {
                      return (
                        <span className="categories-widget-item">
                          {e?.name}
                        </span>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
      {/* <div classNameName="primary-content-area container content-padding">
      <div classNameName="single-post medium-section">
        <div classNameName="post-heading">
          <div classNameName="news-tags">
            <span classNameName="tag-item" style={{ cursor: 'auto' }}>
              <span>{data?.category[0]?.name}</span>
            </span>
          </div>
          <h1>{data?.title}</h1>
          <div classNameName="news-meta">
            <div classNameName="post-author">
              by <span>Unicorn UI</span>,{' '}
              {moment(data?.createdAt).format('MMMM DD,YYYY')}
            </div>
            <ul classNameName="social-icons-list">
              <li classNameName="social-icon">
                <span>
                  <svg classNameName="crumina-icon"></svg>
                </span>
              </li>
              <li classNameName="social-icon">
                <span>
                  <svg classNameName="crumina-icon"></svg>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div classNameName="post-featured-image">
          {data?.URLs[0]?.includes('.mp4') ? (
            <video
              src={Bucket + data?.URLs[0]}
              style={{ width: '100%', height: '100%' }}
              controls
            ></video>
          ) : (
            <img src={Bucket + data?.URLs[0]} classNameName="img-fluid" />
          )}
        </div>
        <div classNameName="post-content">
          {parse(data?.html_code.replace(/!important/g, ''))}
        </div>
      </div>
    </div> */}
    </>
  );
};

export default Blog_details;
